import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Team.css";

// Import Founder Image
import geetaImg from "../../assets/Team/img1.png";

const Team = () => {
  const navigate = useNavigate();

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  const handleMeetTeamClick = () => {
    navigate("/fullteam");
    window.scrollTo(0, 0);
  };

  return (
    <section className="team-section">
      <div className="team-container">
        {/* Section Header */}
        <div className="team-header-wrapper">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="team-top-badge"
          >
            Our Team
          </motion.div>

          <div className="header-content-row">
            <div className="header-left-box">
              <h2 className="team-main-title">Leadership & Core Team</h2>
              <p className="team-description">
                Our team brings deep expertise across renewable energy finance, engineering, and execution. <br className="d-none d-md-block" />
                We work closely with developers, investors, EPCs, and institutions across the full project lifecycle.
              </p>
            </div>
            <div className="header-right-box">
              <button
                className="meet-team-btn"
                onClick={handleMeetTeamClick}
              >
                Meet the Dazbog Team
              </button>
            </div>
          </div>
        </div>

        {/* Founder Card */}
        <motion.div
          className="founder-card-wrapper"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeInUp}
        >
          {/* Card Left / Column 1: Meet the Founder Title */}
          <div className="founder-col-left">
            <div className="founder-eyebrow">
              <span className="founder-tag">FOUNDER</span>
              <span className="founder-line"></span>
            </div>
            <h3 className="founder-heading">
              Meet the <br />
              <span className="founder-highlight">
                <span className="text-brand-green">Found</span>
                <span className="text-brand-blue">er</span>
              </span>
            </h3>
          </div>

          {/* Card Middle / Column 2: Bio & Details */}
          <div className="founder-col-mid">
            <div className="founder-accent-bar"></div>
            <h4 className="founder-name">Ms. Geeta Singh</h4>
            <p className="founder-designation">Founder & Director</p>
            <p className="founder-bio">
              With a vision to accelerate the global transition towards sustainable energy, Ms. Geeta Singh founded Dazbog Power in 2019 to bridge the gap between innovative technology and commercial viability in renewable energy.
            </p>
            <a
              href="https://www.linkedin.com/in/geeta-singh-dazbog"
              target="_blank"
              rel="noopener noreferrer"
              className="founder-linkedin-link"
            >
              <span className="linkedin-icon-box">
                <i className="bi bi-linkedin"></i>
              </span>
              <span>Connect on LinkedIn</span>
              <i className="bi bi-arrow-right arrow-icon"></i>
            </a>
          </div>

          {/* Card Right / Column 3: Founder Portrait & Background Art */}
          <div className="founder-col-right">
            {/* Background scene elements */}
            <div className="founder-bg-scene">
              <div className="orbit-arc-shape">
                <span className="orbit-dot"></span>
              </div>
              <div className="renewable-backdrop"></div>
            </div>

            {/* Founder Portrait */}
            <div className="founder-img-box">
              <img
                src={geetaImg}
                alt="Ms. Geeta Singh - Founder & Director"
                className="founder-portrait-img"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Team;